module.exports = __webpack_public_path__ + "static/media/status-rejected.4c45d678.svg";